<template>
    <div>
        <div class="colspan">
            <div class="weizhi"> <img src="../../assets/images/weizhi.png" alt=""> 您当前所在的位置：</div>
            <el-breadcrumb separator="/">
            <template  v-for="(item,index) in  channleData "   >
                <el-breadcrumb-item 
                    v-if="item.id == id "  
                    :key="index" >
                    <span  class="breadcrumb-hover"  @click="channelGoto(item)"  >{{item.title}} </span> 
                 </el-breadcrumb-item>
                 <el-breadcrumb-item   
                    v-else-if="item.id == second_navId"
                   
                    :key="index" >
                   <span class="breadcrumb-hover"   @click="channelGoto(item)" >{{item.title}}</span>               
                 </el-breadcrumb-item>    
            </template>                
            </el-breadcrumb>
        </div>
    </div>
</template>
<script>
    export default {
        props:{
            positionData:{
                type: Array,
                default:function(){
                    return [];
                }
            } 
        },
                
        data(){
            return {
                id:null,
                second_navId:null,
                channleData:[]
            }
        },
        created(){
            this.id = this.$route.query.id
            this.second_navId = this.$route.query.second_navId
           
            
        },
        methods:{
            goto(item){
                if(this.second_navId){
                    this.$route.push({path:item.path,query:{id:this.id,second_navId:this.second_navId}})
                }else{
                    this.$route.push({path:item.path,query:{id:this.id}})
                }
            },
            // getTemplate(value) {
            //     let param = {};
            //     switch (Number(value)) {
            //         case 1:
            //         param.path = "/project";
            //         param.name = "project";
            //         break;
            //         case 2:
            //         param.path = "/projectInfo";
            //         param.name = "projectInfo";
            //         break;
            //         case 3:
            //         param.path = "/dynamics";
            //         param.name = "dynamics";
            //         break;
            //         case 4:
            //         param.path = "/overView";
            //         param.name = "overView";
            //         break;
            //         default:
            //         param.path = "/";
            //         param.name = "home";
            //     }
            //     return param;
            // }           
        },
        watch:{
            '$route.query.id':function(value) {
                if(value){
                    this.id = value
                    this.menuId = value
                }
                
            },
            '$route.query.second_navId':function(value) {
                if(value){
                    this.second_navId = value
                    this.menuId = this.second_navId?this.second_navId:this.id
                }else if(typeof(value)=='undefined'){
                    
                    this.menuId = this.id
                    this.second_navId = null
                
                }
                
            },
            positionData:function(value){
                if(value){
                    this.channleData = value
                }
            }
          
        }
    }
</script>
<style lang="less" scoped>
    .colspan {
        margin: 0 auto;
        width: 1200px;
        height: 50px;
        background-color: #f3f3f3;
        color: #888888;
        font-size: 16px;
        margin-top: 14px;
        margin-bottom: 20px;
        > .weizhi {
            float: left;
            line-height: 50px;
            margin-left: 10px;
            > img {
                vertical-align:text-top;  
            }
        }
        > .el-breadcrumb {
            line-height: 50px;
        }
        .breadcrumb-hover{
            cursor: pointer;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/Public/breadcrumb.vue